import axios from 'axios';

class StateClass {
  user = {
    name: '',
    trainingsAdmin: false,
    admin: false,
  };
}

export default {
  state: new StateClass(),
  mutations: {
    login(state: StateClass, data: StateClass) {
      state.user = data.user;
    },
  },
  getters: {},
  actions: {
    login(context: { commit: Function; dispatch: Function }, data: object) {
      return new Promise((resolve, reject) => {
        axios
          .post('/api/v1/login', data)
          .then((response) => {
            context.commit('login', { user: response.data });
            resolve();
          })
          .catch((err) => {
            context.dispatch('catchErrHandler', err);
            reject(err);
          });
      });
    },
    logout(context: { commit: Function; dispatch: Function }) {
      return new Promise((resolve, reject) => {
        const action = 'logout';
        axios
          .post('/api/v1/login', { action })
          .then(() => {
            context.commit('login', new StateClass());
            resolve();
          })
          .catch((err) => {
            context.dispatch('catchErrHandler', err);
            reject(err);
          });
      });
    },
    checkLogin(context: { commit: Function; dispatch: Function }) {
      // console.log('kontrolujem session');
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/login')
          .then((response) => {
            if (response.data.login === null) {
              reject('noSession');
            } else {
              context.commit('login', { user: response.data });
              resolve('sessionOK');
            }
          })
          .catch((err) => {
            context.dispatch('catchErrHandler', err);
            reject(err);
          });
      });
    },
  },
};
